$(document).ready(function () {
	// Closing banner
	$('.banner-close-btn').on('click', function (event) {
		event.stopPropagation();
		event.stopImmediatePropagation();

		$('.banner-container').css('display', 'none');
		document.cookie = 'banner_seen=true; expires=Wed, 05 Aug 2040 23:00:00 UTC; path=/';
	});
	$('.banner-submission-btn').on('click', function (event) {
		event.stopPropagation();
		event.stopImmediatePropagation();
		console.log('banner-submitted');
		// banner submission here AND validation
		let email = $('#desktop-email').val();
		if (!email) {
			email = $('#mobile-email').val();
		}
		if (validateEmail(email)) {
			document.getElementById('newsletter-banner').submit();
			$('.banner-container').css('display', 'none');
			document.cookie = 'banner_seen=true; expires=Wed, 05 Aug 2040 23:00:00 UTC; path=/';
		}
	});
	const validateEmail = (email) => {
		return String(email)
			.toLowerCase()
			.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
	};
});
